import { useGetAllProgressionTemplatesQuery, useGetAllProgressionContainersQuery } from "../../libs/progression/api";
import { ProgressionsTable } from "../../components/ProgressionsTable";

export default function Progressions() {
  const { data: templates, isLoading: loadingTemplates, error: errorTemplates } = useGetAllProgressionTemplatesQuery();
  const { data: containers, isLoading: loadingContainers, error: errorContainers } = useGetAllProgressionContainersQuery();

  if (loadingTemplates || loadingContainers) {
    return (
      <div className="animate-pulse p-8">
        <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded mb-4 w-48" />
        <div className="h-64 bg-gray-200 dark:bg-gray-700 rounded" />
      </div>
    );
  }

  if (errorTemplates || errorContainers) {
    return (
      <div className="p-8 text-red-600">
        Errore nel caricamento delle progressioni.
      </div>
    );
  }

  return (
    <ProgressionsTable
      templates={templates || []}
      containers={containers || []}
    />
  );
}
